import { Route } from 'react-router-dom';
import { CreateAssetPage } from './create-asset';
import { EditAssetPage } from './edit-asset';
import { ListAssetsPage } from './list-assets';
import { ViewAssetPage } from './view-asset';
import { RequireAuth } from '/src/components';

export { CreateAssetPage, EditAssetPage, ListAssetsPage, ViewAssetPage };

export const assetsRoutes: React.ReactElement[] = [
  <Route
    path="/assets/create"
    element={
      <RequireAuth>
        <CreateAssetPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/assets/:assetId/edit"
    element={
      <RequireAuth>
        <EditAssetPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/assets"
    element={
      <RequireAuth>
        <ListAssetsPage />
      </RequireAuth>
    }
  />,
  <Route
    path="/assets/:assetId"
    element={
      <RequireAuth>
        <ViewAssetPage />
      </RequireAuth>
    }
  />,
];
